import { create } from 'zustand';
import api from '../lib/api';

const TOKEN_KEY = 'ee_admin_token';
const ADMIN_KEY = 'ee_admin';

const loadInitial = () => {
  try {
    const a = localStorage.getItem(ADMIN_KEY);
    return a ? JSON.parse(a) : null;
  } catch { return null; }
};

export const useAdminStore = create((set) => ({
  admin: loadInitial(),
  token: localStorage.getItem(TOKEN_KEY) || null,
  loading: false,
  error: null,

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const { data } = await api.post('/api/admin/auth/login', { email, password });
      const { token, ...admin } = data;
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
      set({ admin, token, loading: false });
      return admin;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ADMIN_KEY);
    set({ admin: null, token: null });
  },
}));
